import React from 'react';
import './Footer.css';
import { Link } from 'react-router-dom';

function Footer() {
  return (
    <footer className="footer">
      {/* Yellow Top Banner */}

      {/* Bottom Legal Section */}
      <div className="footer-bottom">
        <Link to="/support">Support</Link> |
        <a href="/privacy-policy">Privacy Policy</a> |
        <a href="/terms-and-conditions">Terms and Conditions</a> |
        <span>© {new Date().getFullYear()} Ladyfirst.me</span>
      </div>
    </footer>
  );
}

export default Footer;
